import React from 'react';
import Switcher from './components/Switcher';

import './App.css';

export default function App() {
  return (
    <Switcher />
  );
}
